import { PatchNoteData } from './patch_notes/PatchNoteData.ts';
import { showPatchNotesDialog } from './ui_popup/showPatchNotesDialog.ts';
import { navigateToPage } from './ui_utils/ClientUtils.ts';
import { getProfileURI } from './ui_utils/TestableClientUtils.ts';
import { UIEntryUrlParameterController } from './UIEntryUrlParameterController.ts';
export class UIVersionController {
    setVersion() {
        this.updateStorageVersion(this.thisVersion);
    }
    // refresh() {
    //     location.reload(true)
    // }
    isSameVersion() {
        if (this.getStorageVersion() == null) return false;
        return this.getStorageVersion() == this.thisVersion;
    }
    hasNoVersion() {
        const storageVersion = this.getStorageVersion();
        return storageVersion == 0 || storageVersion == null;
    }
    showPatchnotes() {
        if (this.isSameVersion()) return;
        if (UIEntryUrlParameterController.suppressPopupsOnLoad == true) return;
        this.willShowPatchnoteThisSession = true;
        this.setVersion();
        const pnData = new PatchNoteData();
        showPatchNotesDialog({
            patchNotes: pnData.getLast5(),
            announcements: pnData.getAnnouncements(),
            onExternalClick: (url)=>navigateToPage(url, true, true),
            onProfileClick: (username)=>navigateToPage(getProfileURI(username), true, true)
        });
    }
    constructor(getStorageVersion, thisVersion, updateStorageVersion){
        this.getStorageVersion = getStorageVersion;
        this.thisVersion = thisVersion;
        this.updateStorageVersion = updateStorageVersion;
        this.willShowPatchnoteThisSession = false;
        if (this.hasNoVersion()) {
            this.setVersion();
        }
    }
}
